export default {
  title: {
    textAlign: 'center',
  },
  noDataRow: {
    textAlign: 'center',
    color: 'lightgrey',
    fontSize: 24,
  },
  noData: {
    fontSize: 250,
    color: 'lightgrey',
  },
  datePicker: {
    display: 'none',
  },
  customerCol: {
    width: 200,
  },
  primaryContactCol: {
    width: 180,
  },
  descriptionCol: {
    whiteSpace: 'nowrap',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
  },
  resourcesCol: {
    width: 170,
  },
  taskCountCol: {
    width: 100,
  },
  actionCol: {
    width: 80,
  },
  tableContainer: {
    marginBottom: 90,
  },
  referenceCol: {
    width: 120,
  },
};



// WEBPACK FOOTER //
// ./src/components/Scheduling/styles.js